export default "__VITE_ASSET__COjqbHdZ__"